var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _ellipse, _ellipse2, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOcToDo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1276,
    height: 1091,
    viewBox: "0 0 1276 1091",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M984.885 94.2467C1040.63 76.7373 1078.39 113.453 1090.3 134C1120.68 41.0933 1055.46 2.23333 1000.52 16.08C942.896 28.14 916.393 14.5911 904.035 0C907.757 38.7111 929.138 111.756 984.885 94.2467Z",
    fill: "#223B41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M955.192 94C943.472 131.195 935.432 210.584 997.026 230.58C1023.28 236.829 1061.11 222.546 1075.35 185.946L1086.03 162.29",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.03 138.56C1088.69 134.147 1095.02 128.173 1099.14 139.578C1103.26 150.984 1092.12 159.945 1086.03 163",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1091.03 142C1092.43 142.933 1094.49 145.64 1091.5 149",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1001.03 121C1000.13 127.407 995.853 141.776 986.035 148",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1000.03 156C998.83 153.333 992.538 148.711 986.035 148",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1029.03 110.007C1033.72 109.861 1043.87 111.854 1047.03 121",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M960.035 119C960.91 114.85 964.935 106.643 974.035 107.012",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 975.535,
    cy: 123,
    rx: 4.5,
    ry: 6,
    fill: "#223B41"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1033.03,
    cy: 131,
    rx: 4,
    ry: 5,
    fill: "#223B41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1072.03 226C1115.97 241.061 1212.25 284.605 1245.86 338.289C1279.46 391.974 1241.84 418.368 1210.56 428.211L1149.79 447",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M988.971 229.114L985.832 258.148M1077.76 184L1067.44 247.428M971.035 256.362C989.42 261.424 1037.76 265.116 1084.03 239.388",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M968.747 888.14C913.832 739.577 918.364 610.746 935.745 570.606C995.402 614.763 1109.59 578.618 1148.28 563C1200.03 617.76 1155.32 910.745 1126.5 1050.39C1115.41 1068.65 1091.51 1059.27 1080.95 1052.29L1067.75 955.323L1052.57 1040.25C1044.12 1054.45 1019.13 1051.66 1007.69 1048.49L968.747 888.14Z",
    fill: "#223B41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M948.92 324C922.991 354.848 910.274 478.602 936.403 568.104C961.437 588.222 1015.53 607.447 1146.07 562.739C1152.77 557.374 1152.37 560.486 1151.66 531.575C1150.76 495.436 1151.21 414.7 1141.81 373.178",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1255.91 394C1270.78 412.237 1285.54 469.607 1255.91 502.971C1226.28 536.335 1173.65 568.892 1151.03 581M1151.03 494.002L1189.86 451.4C1192.39 448.411 1196.55 440.548 1192.98 433.014",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M982.802 1060.58C993.562 1060.58 1004.77 1052.66 1008.36 1048.7C1028.26 1054.13 1043.1 1049.83 1048.03 1047V1064.54C1035.66 1077.22 996.924 1079.82 980.112 1074.16C970.024 1069.64 973.593 1060.58 982.802 1060.58Z",
    stroke: "#223B41",
    strokeWidth: 5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1066.16 1061.8C1073.16 1060.91 1081.2 1056.23 1084.34 1054C1098.89 1062.02 1114.2 1059.57 1120.03 1057.34V1067.37C1120.03 1074.05 1114.65 1075.72 1111.28 1076.84L1079.63 1086.31C1071.55 1088.35 1058.08 1090.21 1052.02 1081.3C1045.21 1071.29 1057.41 1062.91 1066.16 1061.8Z",
    stroke: "#223B41",
    strokeWidth: 5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M238.035 798.591V839.978L276.206 861M238.035 798.591L276.206 819.613M238.035 798.591L276.206 771L315.035 792.679M276.206 861V819.613M276.206 861L315.035 834.723V792.679M276.206 819.613L315.035 792.679",
    stroke: "#223B41",
    strokeWidth: 5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M296.793 738L275.035 771.393L313.276 793L335.035 759.607L296.793 738Z",
    stroke: "#223B41",
    strokeWidth: 5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M238.035 733L246.035 751",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M210.035 743L236.035 765",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M209.035 772L225.035 781",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M276.535 773V799.429M276.535 799.429L261.035 810M276.535 799.429L292.035 808.018",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M449.881 996L393.348 975.331C392.559 975.042 392.035 974.292 392.035 973.452V919.255C392.035 917.952 393.259 916.997 394.522 917.315L394.664 917.351M449.881 996V938.5M449.881 996L485.524 956.254C485.853 955.887 486.035 955.411 486.035 954.918V903.471M449.881 938.5L394.664 917.351M449.881 938.5L486.035 903.471M394.664 917.351L429.879 881.944C430.448 881.372 431.304 881.198 432.051 881.502L486.035 903.471",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M986.035 230.5C957.868 228 905.035 235 852.535 262C829.201 274 772.835 286.4 734.035 240C730.035 235.5 725.535 229 724.535 222C723.846 217.183 718.701 213.833 715.535 214M716.035 222C716.035 218.333 716.335 211.1 707.535 211.5M709.535 218.5C708.201 214.667 704.425 207.4 697.625 211M704.035 223C701.868 221.667 699.035 216.2 697.035 209C695.035 201.8 684.535 195.667 679.535 193.5C676.868 192.333 671.535 191.7 671.535 198.5C671.535 204.5 686.235 209.7 687.035 218.5C687.835 227.3 687.368 231.167 687.035 232C686.201 233.667 683.235 235.7 678.035 230.5C672.835 225.3 666.035 224 662.535 225C659.535 226 655.335 229.4 662.535 235C667.884 239.161 685.435 246.9 701.035 266.5C716.635 286.1 736.201 307 744.035 315C760.201 329.167 804.535 354.4 852.535 342",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M986.035 186.906C990.954 191.103 1004.16 194.59 1012.03 184",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M859.756 270C860.502 285.061 860.204 323.147 853.035 355",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M853.035 354.902C870.978 357.741 918.343 357.054 966.035 328",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M841.535 345C843.368 348.5 847.535 353 852.535 353",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M528.035 163.5C529.635 165.9 558.368 218.167 572.535 244M577.035 256C595.201 239 638.435 203.2 666.035 196M622.535 110.5L662.535 189.5M530.535 158.5C543.535 144.167 577.735 116 610.535 118",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M577.535 184L609.035 199.5L614.035 137.5",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M575.535 183H601.035L613.535 139",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M287.035 329.155C288.171 330.837 308.576 367.478 318.636 385.588M321.832 394C334.733 382.082 365.435 356.986 385.035 351.938M354.143 292L382.549 347.381M288.81 325.649C298.042 315.601 322.329 295.856 345.622 297.258",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M322.035 343.25L344.473 354L348.035 311",
    stroke: "#223B41",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M321.035 343H339.153L348.035 312",
    stroke: "#223B41",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M192.535 426.5C198.201 418.333 247.535 379.9 257.535 375.5M223.035 435.5C228.035 427.833 247.035 409.5 265.035 402.5M411.535 272.5L478.035 216M427.035 298C432.535 288.667 460.635 264.3 483.035 257.5",
    stroke: "#223B41",
    strokeOpacity: 0.3,
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M3.03467 948.426V994.776C3.03467 995.258 3.20887 995.724 3.52519 996.088L29.7579 1026.27M3.03467 948.426L29.7579 974.591M3.03467 948.426L48.5448 941.158C49.1678 941.059 49.8012 941.259 50.2537 941.698L76.0347 966.742M29.7579 1026.27V974.591M29.7579 1026.27L74.4101 1017.74C75.3528 1017.56 76.0347 1016.73 76.0347 1015.77V966.742M29.7579 974.591L76.0347 966.742",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M102.035 465.041C102.777 466.13 116.102 489.838 122.672 501.557M124.759 507C133.184 499.289 153.235 483.049 166.035 479.784M145.861 441L164.411 476.835M103.194 462.773C109.223 456.271 125.084 443.495 140.296 444.402",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M125.035 474L139.706 481L142.035 453",
    stroke: "#223B41",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M124.035 474H136.114L142.035 454",
    stroke: "#223B41",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcToDo);
export default __webpack_public_path__ + "static/media/oc-to-do.c54c73049628ae7f2dad2f5953a711fa.svg";
export { ForwardRef as ReactComponent };